import CardPartnerTutorialsTile from './CardPartnerTutorialsTile';

export default CardPartnerTutorialsTile;
